<template>
  <div>
    <PrivacySection />
  </div>
</template>

<script>
import PrivacySection from '@/components/Privacy/PrivacySection.vue';

export default {
  name: 'Privacy',
  components: {
    PrivacySection
  }
}
</script>

<style></style>